import { render, staticRenderFns } from "./TingWuTask.vue?vue&type=template&id=a6c789c0&scoped=true"
import script from "./TingWuTask.vue?vue&type=script&lang=js"
export * from "./TingWuTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c789c0",
  null
  
)

export default component.exports